export default {
     /**
     * 企业微信客户端
     * @returns 
     */
    isWxWork: function () {
        var ua = window.navigator.userAgent;
        return ua.indexOf('wxwork/') > -1;
    },
    /**
     * 微信客户端
     * @returns 
     */
    isWeixin: function() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') > -1;
    }
}